import { RootState } from '@/App/store';

export const selectResources = (state: RootState) => state.i18n.resources;
